
// Chakra imports
import { Box, Grid } from "@chakra-ui/react";

import HeatmapPlot from "views/admin/analysisGlycosylation/components/HeatmapPlot"


import Select from "react-select";
import React, { useState, useEffect } from 'react';

export default function Settings() {
    const [selectedOption, setSelectedOption] = useState(null);  // Maintain the state for the selected option


    // Chakra Color Mode
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Grid
                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(1, 1fr)", lg: "repeat(1, 1fr)" }}
                gap={{ base: "20px", xl: "20px" }}
                mb="20px"
            >
                <HeatmapPlot/>
               
            </Grid>
           
            
        </Box>
    );
}
